<template>
  <div class="container">
    <div class="image">
      <img
        class="image-error-qr"
        src="@/assets/img/1x/QR.png"
        alt="error_qr"
        v-if="$route.params.mje == 'error-solicitud'"
      />
    </div>

    <div class="mensaje-wrapper">
      <div>
        <p
          class="title"
          v-if="$route.params.mje == 'error-solicitud'"
          v-safe-html="config.pasos.mensajeErrorSolicitudCuenta.titulo"
        />
      </div>
      <div class="subtitle">
        <p><span v-safe-html="error.subtitle"></span></p>
      </div>
    </div>
    <div class="button-container">
      <sales-button
        @click.native="goToHomeBanking()"
        class="sales-button"
        label="Ir a Banca Online"
        :color="color"
        :width="width"
        analyticsName="ir a banca online"
        :analyticsModule="analyticsModule"
        v-if="$route.params.mje == 'error-solicitud'"
      />
    </div>
  </div>
</template>

<script>
import SalesButton from "@/components/core/SalesButton";
import errores from "@/config/constants/errores";
import { DO_INGRESO_BANCA_ONLINE } from "../config/constants/action-types";
export default {
  name: "MensajeErrorSolicitudCuenta",
  data() {
    return {
      color: "#1973B8",
      width: "210px"
    };
  },
  components: { SalesButton },
  methods: {
    goToHomeBanking() {
      this.$store.dispatch(DO_INGRESO_BANCA_ONLINE);
      window.open(
        "https://www.bbva.com.ar/fnetcore/loginClementeApp.html?init=acc",
        "Login",
        "noopener"
      );
    }
  },

  computed: {
    error() {
      return errores[this.$route.params.mje];
    },
    analyticsModule() {
      let name = this.error.analyticsModule;
      return name ? name : (this.$route.params.mje + "").replace("-", " ");
    }
  }
};
</script>

<style scoped>
.container {
  padding: 20px;
  width: auto;
  padding-top: 0px;
  text-align: center;
}

.title {
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 26px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  color: #121212;
}

.subtitle {
  width: 100%;
  padding-top: 5%;
  padding-bottom: 7%;
  margin: 0px 0px 20px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  color: #121212;
}
.image {
  margin-top: 60px;
}

.image img:last-child {
  text-align: center;
  width: 122px;
  margin-top: -24px;
}

.button-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.sales-button {
  width: 150px;
  grid-column: 1 / 3;
  grid-row: 1;
  text-align: center;
}

p {
  margin-top: 0px;
}
</style>
